import { createContext } from "react";

export const TextClassContext = createContext<string | undefined>(undefined);
